import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  FormLabel,
  Heading,
  HStack,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  Flex,
  FormControl,
  VStack,
  Badge,
} from "@chakra-ui/react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { DeleteIcon, EditIcon, InfoIcon } from "@chakra-ui/icons";
import { fetchRoster, updateData} from "./Action/action";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";

interface AgentDocument {
  agentId: string;
  agentName: string;
  agentPhoneNumber: string;
  preferredLanguage: string[];
  priority: number;
  originalPriority: number;
  updatedPriority?: number;
  status?: string;
}

interface SlotDocument {
  slotName: string;
  slotStartTime: string;
  slotEndTime: string;
  slotId: string;
  agents: AgentDocument[];
}

interface RosterDocument {
  _id: string;
  day: string;
  numberOfSlots: number;
  slots: SlotDocument[];
  createdAt: string;
  updatedAt: string;
  __v: number;
}

// type AgentDocument1 = {
//   agentId: string;
//   agentName: string;
//   agentPhoneNumber: string;
//   preferredLanguage: string[];
//   priority: number;
//   updatedPriority?: number;
//   status?: string;
// };

interface PriorityTableViewProps {
  detailsData: RosterDocument[];
  onUpdateData: (updatedData: RosterDocument[]) => void;
}


// const languageOptions = [
//   "English",
//   "Hindi",
//   "Malyalam",
//   "Marathi",
//   "Tamil",
//   "Kannada",
//   "Telugu",
// ];

const PriorityTableView: React.FC<PriorityTableViewProps> = ({ detailsData: initialData, onUpdateData }) => {
  const [data, setData] = useState<RosterDocument[]>([]);
  // const [editingAgentId, setEditingAgentId] = useState<string | null>(null);
  // const [editedAgentData, setEditedAgentData] = useState<Partial<AgentDocument>>({});
  const [isSaveButtonVisible, setIsSaveButton] = useState<any>()
  //  const [editedSlotId, setEditedSlotId] = useState<string | null>(null);
  const [editingSlotId, setEditingSlotId] = useState<any>(null);
  // const [editedDay,setEditedDay]=useState<any>()
  const [editedSlotData, setEditedSlotData] = useState<any>({
    slotName: '',
    slotStartTime: '',
    slotEndTime: '',
    slotId: ""
  });


  useEffect(() => {
    if (initialData && initialData.length > 0) {
      // Deep clone to avoid mutating props
      const deepClonedData = JSON.parse(JSON.stringify(initialData));
      setData(deepClonedData);
    }
  }, [initialData]);



  async function fetchData() {
    let data = await fetchRoster()
    setData(data?.data)
    onUpdateData(data?.data)

  }

  const onDragEnd = (result:any, dayKey:any, slotId:any) => {
    
  const newData = [...data];
  const dayIndex = newData.findIndex((d) => d.day === dayKey);

  const slotIndex = newData[dayIndex].slots.findIndex((s) => s.slotId === slotId);

  const slot = newData[dayIndex].slots[slotIndex];
  const originalAgents = slot.agents;
  const agents = Array.from(originalAgents);

  const [removed] = agents.splice(result.source.index, 1);
  agents.splice(result.destination.index, 0, removed);

  const isSameOrder = agents.every((agent, index) => agent.agentId === originalAgents[index].agentId);
  if (isSameOrder) {
    setIsSaveButton("");
    toast.warning("Agents are in the same order");
    return;
  }

  const updatedAgents = agents.map((agent, index) => ({
    ...agent,
    updatedPriority: index + 1,
  }));

  newData[dayIndex].slots[slotIndex].agents = updatedAgents;
  setData(newData);
  setIsSaveButton(newData[dayIndex]);
};



 const handleSaveDay = async (dayKey: string) => {
  const dayIndex = data.findIndex((d) => d.day === dayKey);
  if (dayIndex === -1) {
    toast.error("Day not found");
    return;
  }

  const dayData = data[dayIndex];

  const normalizedSlots = dayData.slots.map((slot) => {
    const remainingAgents = slot.agents
      .filter((a) => a.agentId)
      .sort((a, b) => {
        const aPriority = a.updatedPriority ?? a.priority;
        const bPriority = b.updatedPriority ?? b.priority;
        return aPriority - bPriority;
      });

    const updatedAgents = remainingAgents.map((agent, index) => ({
      agentId: agent.agentId,
      agentName: agent.agentName,
      agentPhoneNumber: agent.agentPhoneNumber,
      preferredLanguage: agent.preferredLanguage,
      priority: agent.updatedPriority ?? agent.priority,
      status: "Ready",
    }));

    return {
      slotId: slot.slotId,
      slotName: slot.slotName,
      slotStartTime: slot.slotStartTime,
      slotEndTime: slot.slotEndTime,
      agents: updatedAgents,
    };
  });

  const result = {
    numberOfSlots: normalizedSlots.length,
    slots: normalizedSlots,
  };

 

  try {
    await updateData(dayData._id, result);
    toast.success("Update successful");
    await fetchData();
    setIsSaveButton("");
  } catch (err: unknown) {
    const errorMessage = (err as Error)?.message || "Unknown error";
    toast.error("Update failed: " + errorMessage);
  }

  return result;
};

  const handleResetDay = (day: string) => {
  // Deep clone the current data
  const updatedData = data.map((dayItem) => {
    if (dayItem.day === day) {
      // Reset only the specified day from initialData
      const originalDay = initialData.find((d) => d.day === day);

      if (!originalDay) return dayItem; // fallback

      return {
        ...originalDay,
        slots: originalDay.slots.map((slot) => ({
          ...slot,
          agents: slot.agents.map(({ updatedPriority, ...agentWithoutUpdated }) => agentWithoutUpdated),
        })),
      };
    }
    return dayItem;
  });
  setData(updatedData);
  setIsSaveButton(""); 
};



  // const handleEditAgent = (day:any,slot:any,agent: AgentDocument) => {
  //   setEditingAgentId(agent.agentId);
  //   setEditedAgentData(agent);
  //   setEditedSlotId(slot?.slotId)
  //   setEditedDay(day?.day)
  
    
  // };

  // const handleCancelEdit = () => {
  //   setEditingAgentId(null);
  //   setEditedAgentData({});
  //   setEditedSlotId(null)
  //   setEditedDay("")
  // };

  const handleDeleteAgent = async (day: any, slot: any, agent: AgentDocument) => {
    // 1. Clone the slots array
    const updatedSlots = [...(day?.slots || [])];

    // 2. Find the index of the target slot
    const slotIndex = updatedSlots.findIndex((s: any) => s.slotId === slot.slotId);
    if (slotIndex === -1) return;

    // 3. Remove the agent from that slot
    const updatedAgents = slot?.agents.filter((a: AgentDocument) => a.agentId !== agent.agentId);

    // 4. Reassign priorities
    updatedAgents.sort((a: any, b: any) => a.priority - b.priority);
    for (let i = 0; i < updatedAgents.length; i++) {
      updatedAgents[i].priority = i + 1;
      if (updatedAgents[i].updatedPriority !== undefined) {
        updatedAgents[i].updatedPriority = i + 1;
      }
    }

    // 5. Replace the agents in the correct slot
    updatedSlots[slotIndex] = {
      ...updatedSlots[slotIndex],
      agents: updatedAgents,
    };

    // 6. Final payload with all slots
    const result = {
      numberOfSlots: day?.numberOfSlots,
      slots: updatedSlots,
    };



    try {
      await updateData(day?._id, result);
      toast.success('Deleted successfully');
      await fetchData();
    } catch (err: unknown) {
      const errorMessage = (err as Error)?.message || 'Unknown error';
      toast.error('Update failed: ' + errorMessage);
    }
  };



//  const areStringArraysEqual = (a: string[] = [], b: string[] = []) => {
//   if (a.length !== b.length) return false;
//   const sortedA = [...a].sort();
//   const sortedB = [...b].sort();
//   return sortedA.every((val, index) => val === sortedB[index]);
// };

function parseTime(timeStr:string) {
  const [hours, minutes] = timeStr.split(":").map(Number);
  return hours * 60 + minutes;
}

// const handleSaveAgentEdit = async (
//   day: any,
//   slot: any,
//   agentDetails: AgentDocument
// ) => {
//   const editableFields: (keyof AgentDocument)[] = [
//     "agentId",
//     "agentName",
//     "agentPhoneNumber",
//     "preferredLanguage",
//   ];
// const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
// const mobileRegex = /^[6-9]\d{9}$/;
//   const originalAgent = slot.agents.find(
//     (a: AgentDocument) => a.agentId === agentDetails.agentId
//   );

//   if (!originalAgent) {
//     toast.error("Agent not found.");
//     return;
//   }

//   if (
//     !emailRegex.test(editedAgentData?.agentId ?? '') ||
//     !mobileRegex.test(editedAgentData?.agentPhoneNumber ?? '')
//   ) {
//     alert("Either Mobile number or agentId is in not correct format")
//     return

//   }

//   if(!editedAgentData?.agentName){
//     alert("Name can't be empty")
//     return

//   }
//   if(editedAgentData?.preferredLanguage&&editedAgentData?.preferredLanguage.length===0){
//     alert("Please select any one of the language")
//     return
//   }

//   const hasChanges = editableFields.some((key) => {
//     const originalValue = originalAgent[key];
//     const newValue = editedAgentData[key];
//     console.log(originalValue,newValue,"yy")

//     if (Array.isArray(originalValue) && Array.isArray(newValue)) {
//       return !areStringArraysEqual(originalValue, newValue);
//     }
    

//     return originalValue !== newValue;
//   });
   
//   if (!hasChanges) {
//     toast.warning("No changes detected.");
//     setEditingAgentId(null);
//     return;
//   }
 

//   slot.agents = slot.agents.map((agent: AgentDocument1) =>
//     agent.agentId === agentDetails.agentId
//       ? { ...agent, ...editedAgentData }
//       : agent
//   );

  
 



//   let allslots=day.slots.map((elem:any)=>{
//      if(elem?.slotId===slot.slotId){
//        elem=slot
//      }
//      return elem
        
//   })

  

//   const result = {
//     numberOfSlots: allslots.length,
//     slots: allslots,
//   };
  

//   try {
//     await updateData(day?._id, result);
//     toast.success("Updated successfully.");
//     await fetchData();
//     setEditingAgentId(null);
//     setEditedAgentData({});
//     setEditedSlotId(null)
//     setEditedDay("")
//   } catch (err: unknown) {
//     const errorMessage = (err as Error)?.message || "Unknown error";
//     toast.error("Update failed: " + errorMessage);
//   }

//   setEditingAgentId(null);
// };


  const istTimeStringToDate = (istTime: string): Date => {
    return new Date(`1970-01-01T${istTime}`);
  };

  const formatISTTime = (istTime: string): string => {
    const [hours, minutes] = istTime.split(":").map(Number);
    const date = new Date(1970, 0, 1, hours, minutes);
    return date.toLocaleTimeString("en-IN", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };
  
  const timeStrToMinutes = (timeStr: string): number => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    return hours * 60 + minutes;
    };


  const handleEditSlot = (slot: any) => {
    setEditingSlotId(slot.slotId); 
    setEditedSlotData({
      slotName: slot.slotName,
      slotStartTime: slot.slotStartTime,
      slotEndTime: slot.slotEndTime,
      slotId: slot.slotId
    });
  };

  const handleCancelSlotEdit = () => {
    setEditingSlotId(null);
  };

  const handleSaveSlotEdit = async (day: any,id:string) => {
  
    let { slotStartTime, slotEndTime, slotName, slotId } = editedSlotData;
 
  
     if(slotEndTime==="00:00"){
      slotEndTime = "24:00"
     }
    if (slotStartTime === "00:00" && slotStartTime === slotEndTime) {
      slotStartTime = "00:00"
      slotEndTime = "24:00"

    }
     if (timeStrToMinutes(slotStartTime) > timeStrToMinutes(slotEndTime)) {
      toast.warning("Please select an end time that comes after the start time.");
      return

    }

    let dayData = data.filter((elem) => elem.day === day)
    const result = dayData[0]?.slots?.map((elem) => {
      if (elem?.slotId === slotId) {
        return {
          ...elem,
          slotStartTime,
          slotEndTime,
          slotName,
        };
      }
      return elem;
    });

    // Overlap check
    const hasOverlap = result.some((slotA, i) => {
      return result.some((slotB, j) => {
        if (i === j) return false;
        const startA = parseTime(slotA.slotStartTime);
        const endA = parseTime(slotA.slotEndTime);
        const startB = parseTime(slotB.slotStartTime);
        const endB = parseTime(slotB.slotEndTime);

        return startA < endB && startB < endA;
      });
    });

    if (hasOverlap) {
      toast.error("Slot times are overlapping with existing slots.");
      return;
    }
    
     let payload={
       numberOfSlots: day?.numberOfSlots,
        slots: result,

     }

  try {
    let response=await updateData(dayData[0]?._id,payload);
    if(response?.StatusCode===200){
       toast.success('Updated successfully');
       await fetchData();

    }
   
  } catch (err: unknown) {
    toast.error('Update failed: ' + err);
  }

  setEditingSlotId(null);
};


  const handleDeleteSlot = async (day: any, slot: any) => {
    if (window.confirm("Are you sure you want to delete this slot?")) {
      // Filter out the deleted slot
      let updatedSlots = day.slots?.filter((elem: any) => elem.slotId !== slot?.slotId);

      // Reassign slotIds starting from 1
      updatedSlots = updatedSlots.map((slot: any, index: number) => ({
        ...slot,
        slotId: String(index + 1), 
      }));

      const result = {
        numberOfSlots: updatedSlots.length,
        slots: updatedSlots,
      };

      try {
        await updateData(day?._id, result);
        toast.success("Deleted successfully");
        await fetchData();
      } catch (err: unknown) {
        const errorMessage = (err as Error)?.message || "Unknown error";
        toast.error("Deletd Failed: " + errorMessage);
      }
    }
  };




  return (
    <Box p={6}>
      {data.length === 0 ? (
        <Text fontSize="lg" fontWeight="bold" color="gray.500" textAlign="center">
          No roster data available.
        </Text>
      ) : (
        <Accordion allowMultiple>
            {[...data]
              .sort((a, b) => {
                const dayOrder = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
                return dayOrder.indexOf(a.day) - dayOrder.indexOf(b.day);
              })
              .map((day) => (
            <AccordionItem key={day.day} border="1px solid #eee" borderRadius="md" mb={4}>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    <Heading size="md">{day.day}</Heading>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>

              <AccordionPanel pb={4}>
                    {[...day.slots]
                      .sort((a, b) => a.slotStartTime.localeCompare(b.slotStartTime))
                      .map((slot, slotIdx) => {
                  const sortedAgents = slot.agents.sort((a, b) => (a?.priority || 0) - (b?.priority || 0));

                  return (
                    <Box key={slot.slotName} mb={6}>
                      <Box key={slot.slotId} mb={6}>
                        {editingSlotId === slot.slotId ? (
                          <Box p={4} borderWidth="1px" borderRadius="md" bg="gray.50">
                            <VStack spacing={4} align="start">
                              <FormControl>
                                <FormLabel>Slot Name</FormLabel>
                                <Input
                                  size="sm"
                                  value={editedSlotData.slotName}
                                  onChange={(e) =>
                                    setEditedSlotData({ ...editedSlotData, slotName: e.target.value })
                                  }
                                />
                              </FormControl>

                              <FormControl>
                                <FormLabel>Start Time</FormLabel>
                                <DatePicker
                                  selected={
                                    editedSlotData.slotStartTime
                                      ? istTimeStringToDate(editedSlotData.slotStartTime)
                                      : null
                                  }
                                  onChange={(date) => {
                                    if (date) {
                                      const time = date.toTimeString().slice(0, 5);
                                      setEditedSlotData((prev: any) => ({
                                        ...prev,
                                        slotStartTime: time,
                                      }));
                                    }
                                  }}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={15}
                                  timeCaption="Time"
                                  dateFormat="HH:mm"
                                  placeholderText="Select time"
                                />
                              </FormControl>

                              <FormControl>
                                <FormLabel>End Time</FormLabel>
                                <DatePicker
                                  selected={
                                    editedSlotData.slotEndTime
                                      ? istTimeStringToDate(editedSlotData.slotEndTime)
                                      : null
                                  }
                                  onChange={(date) => {
                                    if (date) {
                                      const time = date.toTimeString().slice(0, 5);
                                        setEditedSlotData((prev: any) => ({
                                          ...prev,
                                          slotEndTime: time,
                                        }));
                                      }
                                  }}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={15}
                                  timeCaption="Time"
                                  dateFormat="HH:mm"
                                  placeholderText="Select time"
                                />
                              </FormControl>

                              <HStack>
                                <Button size="sm" colorScheme="green" onClick={() => handleSaveSlotEdit(day.day,slot.slotId)}>
                                  Save
                                </Button>
                                <Button size="sm" variant="outline" onClick={handleCancelSlotEdit}>
                                  Cancel
                                </Button>
                              </HStack>
                            </VStack>
                          </Box>
                        ) : (
                          <Flex justify="space-between" align="center" mb={2}>
                            <Text fontWeight="bold">
                              {slot.slotName} ({formatISTTime(slot.slotStartTime)} -{" "}
                              {formatISTTime(slot.slotEndTime)})
                            </Text>
                            <HStack spacing={2} wrap="wrap">
                              <Button
                                size="xs"
                                leftIcon={<EditIcon />}
                                variant="outline"
                                onClick={() => handleEditSlot(slot)}
                              >
                                Edit Slot
                              </Button>
                              <Button
                                size="xs"
                                leftIcon={<DeleteIcon />}
                                colorScheme="red"
                                variant="outline"
                                onClick={() => handleDeleteSlot(day, slot)}
                              >
                                Delete Slot
                              </Button>
                            </HStack>

                          </Flex>
                        )}
                      </Box>

                      <DragDropContext onDragEnd={(result) => onDragEnd(result, day.day, slot.slotId)}>
                        <Droppable droppableId={`slot-${day.day}-${slot.slotId}`}>

                          {(provided) => (
                            <Box ref={provided.innerRef} {...provided.droppableProps} overflow="auto">
                              <Box overflowX="auto">
                                <Table variant="simple" size="sm" minW="1000px">
                                  <Thead>
                                    <Tr bg="gray.100" position="sticky" top={0} zIndex={1}>
                                      <Th>Current Priority</Th>
                                      <Th>Updated Priority</Th>
                                      <Th>Name</Th>
                                      <Th>Email</Th>
                                      <Th>Phone</Th>
                                      <Th>Languages</Th>
                                      <Th>Actions</Th>
                                    </Tr>
                                  </Thead>
                                  <Tbody>
                                    {sortedAgents.map((agent, index) => (
                                      <Draggable
                                        key={agent.agentId}
                                        draggableId={agent.agentId}
                                        index={index}
                                      >
                                        {(provided, snapshot) => (
                                          <Tr
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            _hover={{ bg: "gray.50" }}
                                            bg={snapshot.isDragging ? "gray.100" : "white"}
                                            style={{ ...provided.draggableProps.style }}
                                          >
                                            <Td>{agent.priority}</Td>
                                            <Td>{agent.updatedPriority}</Td>
                                            <Td>
                                              {agent.agentName}
                                            </Td>
                                            <Td>
                                              {agent.agentId}
                                            </Td>
                                            <Td>
                                              {agent.agentPhoneNumber}
                                            </Td>
                                            <Td>
                                              {Array.isArray(agent?.preferredLanguage) &&
                                                agent.preferredLanguage.map((lang) => (
                                                  <Badge key={lang} colorScheme="blue" mr={1}>
                                                    {lang}
                                                  </Badge>
                                                ))
                                              }

                                            </Td>
                                            <Td isNumeric>
                                              <HStack spacing={2} justifyContent="flex-end" wrap="wrap">
                                                {/* {(editedSlotId===slot?.slotId)&&(editingAgentId === agent.agentId)&&(editedDay === day?.day) ? (
                                                  <>
                                                    <Button
                                                      size="xs"
                                                      colorScheme="green"
                                                      onClick={() => handleSaveAgentEdit(day, slot,agent)}
                                                    >
                                                      Save Agent
                                                    </Button>
                                                    <Button
                                                      size="xs"
                                                      variant="outline"
                                                      onClick={handleCancelEdit}
                                                    >
                                                      Cancel
                                                    </Button>
                                                  </>
                                                ) : (
                                                  <Button
                                                    size="xs"
                                                    leftIcon={<EditIcon />}
                                                    variant="outline"
                                                    onClick={() => handleEditAgent(day,slot,agent)}
                                                  >
                                                    Edit Agent
                                                  </Button>
                                                )} */}
                                                <Button
                                                  size="xs"
                                                  leftIcon={<DeleteIcon />}
                                                  colorScheme="red"
                                                  variant="outline"
                                                  onClick={() => {
                                                    const confirm = window.confirm("Are you sure you want to delete this agent?");
                                                    if (confirm) {
                                                      handleDeleteAgent(day, slot, agent);
                                                    }
                                                  }}
                                                >
                                                  Delete Agent
                                                </Button>
                                              </HStack>

                                            </Td>
                                          </Tr>
                                        )}
                                      </Draggable>
                                    ))}
                                    {provided.placeholder}
                                  </Tbody>
                                </Table>
                              </Box>
                            </Box>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </Box>


                  );
                })}

                <HStack mt={4} spacing={3}>
                  <Button
                    colorScheme="green"
                    size="sm"
                    onClick={() => {
                      handleSaveDay(day.day)
                   
                    }}
                    isDisabled={!(isSaveButtonVisible === day)}
                  >
                    Save Changes
                  </Button>
                  <Button
                    size="sm"
                    colorScheme="green"
                    onClick={() => handleResetDay(day.day)}
                    isDisabled={!(isSaveButtonVisible === day)}
                  >
                    Reset
                  </Button>
                </HStack>


                <FormLabel display="flex" alignItems="center" mt={2}>
                  Note:
                  <Tooltip
                    label="You can save changes after shuffling the agent positions. Updated priorities will be stored."
                    fontSize="sm"
                    hasArrow
                    placement="right"
                  >
                    <span>
                      <InfoIcon ml={1} color="gray.500" cursor="pointer" />
                    </span>
                  </Tooltip>
                </FormLabel>
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      )}
    </Box>
  );
};

export default PriorityTableView;